import React from 'react';

import { cn } from '../../../../../lib/utils';
import { CPT_TASK_LOG_TONE, CptViewTone } from './constants';

interface TotalSummaryProps {
    value: any[];
    label?: string;
    sumField: string;
    unit?: string;
    className?: string;
    tone?: CptViewTone;
}

export const TotalSummary: React.FC<TotalSummaryProps> = ({
    value = [],
    label = 'Total',
    sumField,
    unit = '',
    className,
    tone = 'default',
}) => {
    const total = value.reduce(
        (sum, item) => sum + (Number(item[sumField]) || 0),
        0
    );
    const isCptTaskLogTone = tone === CPT_TASK_LOG_TONE;
    const shouldHighlightTotal = total > 8;

    return (
        <div
            className={cn(
                'flex items-center justify-between rounded-lg bg-muted/50 p-4',
                className
            )}
        >
            <span
                className={cn(
                    'text-sm font-medium',
                    isCptTaskLogTone &&
                        'uppercase tracking-[0.18em] text-[#a5a5a5]'
                )}
            >
                {label}
            </span>
            {isCptTaskLogTone ? (
                <span
                    className={cn(
                        'inline-flex items-end gap-2 rounded-lg px-4 py-2',
                        shouldHighlightTotal &&
                            'border border-[#355847] bg-[#24372D]'
                    )}
                >
                    <span
                        className={cn(
                            'text-4xl font-semibold leading-none',
                            shouldHighlightTotal
                                ? 'text-[#86E8A8]'
                                : 'text-foreground'
                        )}
                    >
                        {total}
                    </span>
                    {unit && (
                        <span className="pb-0.5 text-lg font-medium leading-none text-[#8F8EA2]">
                            {unit}
                        </span>
                    )}
                </span>
            ) : (
                <span className="text-xl font-bold font-mono">
                    {total} {unit}
                </span>
            )}
        </div>
    );
};
